import { render, staticRenderFns } from "./AmendmentsActivity.vue?vue&type=template&id=6ab2efba&scoped=true&"
import script from "./AmendmentsActivity.vue?vue&type=script&lang=js&"
export * from "./AmendmentsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab2efba",
  null
  
)

export default component.exports